import { RenderResult } from '@dojo/framework/core/interfaces';
import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './IndustryExpertise.m.css';

const health1Img = require('../assets/images/development/industry/health1.svg');
const health2Img = require('../assets/images/development/industry/health2.svg');
const health3Img = require('../assets/images/development/industry/health3.svg');
const financeImg = require('../assets/images/development/industry/finance.svg');
const officeImg = require('../assets/images/development/industry/office.svg');
const prisonImg = require('../assets/images/development/industry/prison.svg');

export interface IndustryExpertiseChildren {
	content?: RenderResult;
	title?: RenderResult;
}

const factory = create().children<IndustryExpertiseChildren | undefined>();

export const IndustryExpertise = factory(function IndustryExpertise({ children }) {
	const defaultChildren = {
		title: 'Enterprise Industry Expertise',
		content: (
			<p>
				Among SitePen's greatest strengths is its wide-ranging experience across multiple
				industries. We have worked with some of the largest names in multiple markets with
				each engagement serving to refine our ability to address each enterprise's
				individual needs. Our industry expertise includes Financial Services, Healthcare,
				Hospitality and Public Safety.
			</p>
		)
	};
	const [childProperties = defaultChildren] = children();
	const { title, content } = childProperties;

	return (
		<section classes={[css.root, css.industry]}>
			<div classes={css.industryLeading}>
				<img src={officeImg} classes={css.image} alt="" loading="lazy" />
				<img
					src={financeImg}
					classes={[css.image, css.industryMiddle]}
					alt=""
					loading="lazy"
				/>
				<img src={health2Img} classes={css.image} alt="" loading="lazy" />
			</div>
			<div classes={css.contentWrapper}>
				<h2>{title}</h2>
				{content}
			</div>
			<div classes={css.industryTrailing}>
				<img src={health1Img} classes={css.image} alt="" loading="lazy" />
				<img
					src={prisonImg}
					classes={[css.image, css.industryMiddle]}
					alt=""
					loading="lazy"
				/>
				<img src={health3Img} classes={css.image} alt="" loading="lazy" />
			</div>
		</section>
	);
});

export default IndustryExpertise;
